import useOutsideClick from 'hooks/useOutsideClick';
import { useEffect, useRef, useState } from 'react';
import { useController, useForm } from 'react-hook-form';
import { useSearchParams } from 'react-router-dom';
import DropdownV2 from 'style-guide/DropdownV2';
import { Search } from 'style-guide/Icons';
import Text from 'style-guide/Typography/Text';
import SearchComponent from './SearchComponent';
import DropdownComponentWrapper from './style/DropdownComponentWrapper';

const SearchDropdown = ({ name, title, placement }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [visible, setVisible] = useState(false);

  const ref = useRef(null);
  const excludedRef = useRef(null);
  const searchValue = searchParams.get(name);

  const { handleSubmit, control, setFocus } = useForm({
    defaultValues: { [name]: '' },
    mode: 'onChange',
  });

  const { field } = useController({
    name,
    control,
  });

  useEffect(() => {
    if (!field.value && searchValue) {
      searchParams.delete(name);
      setSearchParams(searchParams);
    }
  }, [field.value, name, searchParams, searchValue, setSearchParams]);

  useOutsideClick({
    ref,
    excludedRef,
    cb: () => setVisible(false),
  });

  return (
    <DropdownComponentWrapper>
      <div className='d-flex align-items-center'>
        <DropdownV2
          visible={visible}
          overlay={
            <SearchComponent
              field={field}
              setVisible={setVisible}
              visible={visible}
              ref={excludedRef}
              name={name}
              handleSubmit={handleSubmit}
              setFocus={setFocus}
              control={control}
            />
          }
          placement={placement || 'bottom'}
        >
          <div
            ref={ref}
            onClick={() => {
              setVisible((item) => !item);
            }}
            className='d-flex align-items-center justify-content-space-between'
          >
            <Text variant={3} className='title'>
              {title}
            </Text>
            <Search width={16} className='search-icon pointer' />
          </div>
        </DropdownV2>
      </div>
    </DropdownComponentWrapper>
  );
};

export default SearchDropdown;
